import React, { createContext, useContext } from 'react';

import { type LeaguePrimarySection } from '@/lib/routes';

interface LeagueContextValue {
  id: string;
  resolvedSeasonId: string | null;
  league: any;
  leagueSeasons: any[];
  permissions: {
    isOwner: boolean;
    isManager: boolean;
    canInvite: boolean;
    canLeave: boolean;
  } | undefined;
  permissionsLoading: boolean;
  leagueScoringSystem: 'oddsBased' | 'totalWins';
  seasonWeekMode: string;
  seasonWeekOptions: any[];
  pickerWeekOptions: any[];
  activeWeek: any | null;
  handleWeekChange: (value: string, section?: LeaguePrimarySection) => void;
  handleSeasonChange: (value: string, section?: LeaguePrimarySection) => void;
  pickerSelectedValue: string;
  isSaving: number;
  dirtyTiebreakerKeys: Set<string>;
  setDirtyTiebreakerKeys: React.Dispatch<React.SetStateAction<Set<string>>>;
  completedPicks: number;
  totalPickTargets: number;
  clearablePicks: any[];
  availableForRandomPicks: any[];
  clearPicksMutation: any;
  randomPicksMutation: any;
  handleRandomPicks: () => void;
  initialPicksLoading: boolean;
  sortedGames: any[];
  gamesLoading: boolean;
  userPicksByBetId: Map<string, { pick: any; game: any }>;
  picksQueryKey: any;
  isMarchMadness: boolean;
  isWorldCupTournament: boolean;
  mmStatus: any;
  mmDraftState: any;
  mmOverview: any;
  mmBracket: any;
  mmSelectedRoundDetail: any;
  mmSelectedRoundKey: string | null;
  isLoading: boolean;
}

const LeagueContext = createContext<LeagueContextValue | null>(null);

export function LeagueProvider({ children, value }: { children: React.ReactNode; value: LeagueContextValue }) {
  return <LeagueContext.Provider value={value}>{children}</LeagueContext.Provider>;
}

export function useLeagueContext() {
  const context = useContext(LeagueContext);
  if (!context) {
    throw new Error('useLeagueContext must be used within a LeagueProvider');
  }
  return context;
}
